module.exports = __webpack_public_path__ + "media/src/application/media/logo-bg-c97bad0bd7e63054a3f627d9fccac345.png";